import * as d3 from 'd3';
import { PRIMARY_COLOR } from '../../../../components/Common/StyleElement';

const FixedSizeContextMenu = ({ x, y, items, svg_width }) => {
    var height,
        width,
        x_val,
        margin = 15,
        rescale = true;

    menu(x, y, items)

    function menu(x, y, items) {
        d3.select('.context-menu').remove();
        scaleItems();

        if (x + (width + margin * 2) > svg_width) {
            x_val = x - (width + margin * 2)
        } else {
            x_val = x
        }

        // Draw the menu
        var contextMenu = d3.select('#chartPlot')
            .append('g').attr('class', 'context-menu')

        contextMenu.append('rect')
            .attr('width', width + margin * 2)
            .attr('height', (height + margin) * items.length)
            .attr('x', x_val)
            .attr('y', y)
            .attr('rx', 5)
            .attr('ry', 5)
            .style('fill', '#333333')
            .style('stroke', '#333333')
            .style('stroke-width', '3px');

        contextMenu.selectAll('tmp')
            .data(items).enter()
            .append('g')
            .attr('class', 'menu-entry')
            .style("cursor", "pointer")
            .on('mouseover', function () {
                d3.select(this).select('rect')
                    .style('fill', PRIMARY_COLOR)
            })
            .on('mouseout', function () {
                d3.select(this).select('rect')
                    .style('fill', 'none')
            })
            .on('click', function (event, d) {
                d.action()
            });

        d3.selectAll('.menu-entry')
            .append('rect')
            .attr('x', x_val)
            .attr('y', function (d, i) {
                return y + (i * (height + margin));
            })
            .attr('width', width + margin * 2)
            .attr('height', height + margin)
            .attr('rx', 5)
            .attr('ry', 5)
            .style('fill', 'none')
            .style('stroke', '#333333')
            .style('stroke-width', '3px');

        d3.selectAll('.menu-entry')
            .append('text')
            .text(function (d) { return d.title; })
            .attr("alignment-baseline", "middle")
            .attr('x', x_val + margin)
            .attr('y', function (d, i) { return y + (i * (height + margin)); })
            .attr('dy', height)
            .style('fill', 'white')
            .style('font-size', '13')

        // Other interactions
        d3.select('body')
            .on('click', function () {
                d3.select('.context-menu').remove();
            });

    }

    // Automatically set width, height, and margin;
    function scaleItems() {
        if (rescale) {
            d3.select('#chartPlot').selectAll('tmp')
                .data(items).enter()
                .append('text')
                .attr('class', 'tmp')
                .attr("text-anchor", "middle")
                .attr("alignment-baseline", "middle")
                .style('font-size', '13')
                .text(function (d) { return d.title });
            var z = d3.selectAll('.tmp').nodes().map(function (x) {
                return x.getBBox();
            });
            width = d3.max(z.map(function (x) { return x.width; }));
            height = d3.max(z.map(function (x) { return x.height }));

            // cleanup
            d3.selectAll('.tmp').remove();
            rescale = false;
        }
    }

    return menu;
}

export default FixedSizeContextMenu